let Backbone = require("backbone");

let main = function (Backbone) {
    return Backbone.Model.extend({
        name: function() {
            return this.get('name');
        }
    });
};

let exportedValue = main(Backbone);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/RestaurantModel.js